<template>
    <div class="simple-form">
        <div class="form-group">
            <div class="form-label">
                <label>名称：</label>
            </div>
            <div class="form-value">
                <span>{{assetKind.name}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>编码：</label>
            </div>
            <div class="form-value">
                <span>{{assetKind.code}}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>资产属性：</label>
            </div>
            <div class="form-value">
                <span>{{assetNatureMap[assetKind.assetNature]}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import assetApi from '../../api/asset'

    export default {
        name: 'swb-asset-kind-detail',
        desc: '',
        props: {
            id: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                assetKind: {},
                assetNatureMap: getEnumMap('assetNature', 'value2text'),
            }
        },
        created: function () {
            this.getAssetKind();
        },
        methods: {
            getAssetKind: function () {
                let self = this;
                let postData = {};
                postData.id = self.id;
                let theLoad = MsgBox.loading();
                assetApi.getAssetKind(postData, function (result) {
                    theLoad.hide();
                    if(result.type === 'info') {
                        let assetKind = result.data;
                        self.assetKind = Utils.merge({}, assetKind);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/categ/AssetKindDetail.vue